export default __webpack_public_path__ + "static/media/IATA.3430c731.png";